import { Nullable } from "@/api/ApiClient";
import { WithCustomerInfo } from "./DocumentClientType";

export interface QuoteFormCore extends WithCustomerInfo<{
    id: string,
    numero: number,
    nombre_factura: string,
    tipo_identificacion: string,
    identificacion: string,
    tel1: string,
    tel1_cd: string,
    tel2: string,
    tel2_cd: string,
    email: string,
    direccion: string,
    clientActivitycode: string,
    activitycode: string,
    fecha: string,
    cerrada: boolean,
    approval_status: string,
    porcenta_descuento: number,
    descuento: number,
    discountCode: string,
    subtotal: number,
    impuestos: number,
    impuestos_servicio: number,
    total: number,
    reserved_until: string,
    comments: string,
    exchange_rate: number,
    customfields: string,
    otros_cargos: string,
    reference_number: string,
    selected_logo: number,
    exenta: boolean,
    descuento_con_nota: boolean,
    clientId: string,
    client: any,
    currencyId: string,
    currency: any,
    quoteProducts: any[],
    user: string,
}> { }

export type QuoteFormData = Nullable<QuoteFormCore>;
export const QuoteRelatedAttributes: Array<keyof QuoteFormData> = ["plazo", "client", "currency", "quoteProducts"];